import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system';
import React from 'react';

import { Alert } from '@/components/molecules/Alert';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly onAdd: () => void;
  readonly onRemove: () => void;
  readonly currentMarkupBps: number | null;
  readonly disabled?: boolean;
}

export const FxMarkupBanner: React.FC<Props> = (props: Props): React.ReactElement => {
  const { onAdd, onRemove, currentMarkupBps, disabled } = props;
  const tr = useTranslator();
  const hasMarkup = currentMarkupBps !== null && currentMarkupBps > 0;

  if (hasMarkup) {
    return (
      <Alert
        variant="info"
        sx={styles.container}
        rightIcon={
          <Stack direction="row" gap={1}>
            <Button variant="dark" size="compact" onClick={onAdd} disabled={disabled}>
              {tr('EDIT')}
            </Button>
            <Button variant="light" size="compact" onClick={onRemove}>
              {tr('REMOVE')}
            </Button>
          </Stack>
        }>
        <Typography color="primary">{tr('YOUR_FX_MARKUP')}</Typography>
        <Typography variant="h6">{currentMarkupBps} bps</Typography>
      </Alert>
    );
  }

  return (
    <Alert
      variant="info"
      sx={styles.container}
      rightIcon={
        <Button variant="dark" size="compact" onClick={onAdd} disabled={disabled}>
          {tr('ADD')}
        </Button>
      }>
      <Typography variant="h7" color="primary">
        {tr('ADD_FX_MARKUP')}
      </Typography>
      <Typography color="custom.LightGray">{tr('ADD_FX_MARKUP_DESCRIPTION')}</Typography>
    </Alert>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    borderRadius: '24px',
    px: 4,
    py: 2.5,
    gap: 4,
  },
};
